module.exports = __webpack_public_path__ + "static/Icon_HomeLoan_Large-a2c543125466f681c892b23eb6216130.png";